import { ApiCaller } from '../../utils/api'
import { URLS } from '../../utils/url'
import { Message } from 'element-ui'
import { customTruncate } from '../../libs/custom'

const state = {
  newMenuCoupon: {
    id: '',
    name: '',
    total_uses: undefined,
    unitprice: undefined,
    duration: undefined,
    tax_included: true,
    tax_percent: 10,
    time_limit_flag: false,
    number_month_expired: undefined,
    therapist_ids: []
  },
  queryMenuCoupon: {
    query: '',
    isValid: true,
    filter: []
  },
  isValid: true,
  menuCouponRules: {
    clinic: [
      { required: true, message: '店舗を選択してください', trigger: 'blur' },
    ],
    name: [
      { required: true, message: '回数券名を入力してください', trigger: 'blur' },
      { max: 100, message: '回数券名は100文字以内で入力してください。', trigger: 'blur' },
    ],
    clinic_name: [
      { required: true, message: '販売価格を入力してください', trigger: 'blur' },
    ],
    total_uses: [
      { required: true, message: '提供回数を入力してください', trigger: 'blur' },
    ],
    unitprice: [
      { required: true, message: '販売価格を入力してください', trigger: 'blur' },
    ],
    input_price: [
      { required: true, message: '販売価格を入力してください', trigger: 'blur' },
    ],
    duration: [
      { required: true, message: '提供時間を入力してください', trigger: 'blur' },
    ],
    number_month_expired: [
      { required: true, message: '有効期限を入力してください', trigger: 'blur' },
    ],
  },
  menuCouponVisible: false,
  menuCouponIsEdit: false,
  menuCoupons: [],
  clinicMenuCoupons: [],
  editMenuCoupon: {},
  dropdownMenuCoupons: [],
  clinicNameMenuCoupons: [],
  ownerMenuCoupons: [],
}

const mutations = {
  SET_NUMBER_MONTH_EXPIRED_RULE(state, payload) {
    state.menuCouponRules.number_month_expired[0].required = payload
  },
  SET_MENU_COUPONS(state, menuCoupons) {
    state.menuCoupons = menuCoupons
  },
  SET_OWNER_MENU_COUPONS(state, ownerMenuCoupons) {
    state.ownerMenuCoupons = ownerMenuCoupons
  },
  SET_DROPDOWN_MENU_COUPONS(state, dropdownMenuCoupons) {
    dropdownMenuCoupons.forEach(dropdownMenuCoupon => dropdownMenuCoupon.name = customTruncate(dropdownMenuCoupon.name, 20))
    state.dropdownMenuCoupons = dropdownMenuCoupons
  },
  SET_CLINIC_NAME_MENU_COUPONS(state, clinicNameMenuCoupons) {
    state.clinicNameMenuCoupons = clinicNameMenuCoupons
  },
  SET_MENU_COUPON_VISIBLE(state, payload) {
    state.menuCouponVisible = payload
  },
  SET_QUERY_MENU_COUPON(state, payload) {
    state.queryMenuCoupon = payload
  },
  SET_EDIT_MENU_COUPON(state, editMenuCoupon) {
    state.editMenuCoupon = JSON.parse(JSON.stringify(editMenuCoupon))
  },
  SET_MENU_COUPON_IS_EDIT(state, payload) {
    state.menuCouponIsEdit = payload
  },
  SET_IS_VALID(state, payload) {
    state.queryMenuCoupon.isValid = payload
  },
  SET_CLINIC_MENU_COUPON(state, clinicCoupons) {
    state.clinicMenuCoupons = clinicCoupons
  }
}
const actions = {
  async fetchMenuCoupons({ state, commit, rootState }) {
    const response = await ApiCaller().get(URLS.MANAGER_MENU_COUPONS(), {
      params: Object.assign({}, rootState.page, { query: state.queryMenuCoupon.query,
                                                  q: state.queryMenuCoupon.q,
                                                  filter: state.queryMenuCoupon.filter,
                                                  paginatePage: true,
                                                  isValid: state.queryMenuCoupon.isValid })
    })
    if (response) {
      commit('SET_MENU_COUPONS', response.data.data)
      commit('page/SET_TOTAL', response.data.total, { root: true })
    }
  },
  async fetchClinicMenuCoupons({ state, commit, rootState }, clinic_id) {
    const response = await ApiCaller().get(URLS.OWNER_CLINIC_MENU_COUPON(), {
      params: {clinic_id: clinic_id}
    })
    if (response) {
      commit('SET_CLINIC_MENU_COUPON', response.data.data)
      commit('page/SET_TOTAL', response.data.total, { root: true })
    }
  },
  async createMenuCoupon({ commit, dispatch }, payload) {
    const response = await ApiCaller().post(URLS.MENU_COUPONS(), {
      menu_coupon: Object.assign({}, state.editMenuCoupon)
    })

    if (response) {
      if (response.data.success) {
        Message.success({
          message: response.data.message,
          type: 'success'
        })
        commit('SET_MENU_COUPON_VISIBLE', false)
        dispatch('fetchOwnerMenuCoupons')
      } else {
        Message.error({
          message: response.data.message
        })
      }
    }
  },
  async createManagerMenuCoupon({ commit, dispatch }, payload) {
    const response = await ApiCaller().post(URLS.MANAGER_MENU_COUPONS(), {
      menu_coupon: Object.assign({}, state.editMenuCoupon, {
        clinic_id: state.editMenuCoupon.clinic.id
      })
    })

    if (response.status === 200) {
      Message.success({
        message: response.data.message,
        type: 'success'
      })
      commit('SET_MENU_COUPON_VISIBLE', false)
      dispatch('fetchMenuCoupons')
    } else {
      Message.error({
        message: response.data.message
      })
    }

  },
  async updateMenuCoupon({ commit, dispatch }, payload) {
    const response = await ApiCaller().put(URLS.MENU_COUPON(payload.id), {
      menu_coupon: Object.assign({}, state.editMenuCoupon)
    })

    if (response.status === 200) {
      Message.success({
        message: response.data.message
      })
      commit('SET_MENU_COUPON_VISIBLE', false)
      dispatch('fetchOwnerMenuCoupons')
    } else {
      Message.error({
        message: response.data.message
      })
    }

  },
  async updateManagerMenuCoupon({ commit, dispatch }, payload) {
    const response = await ApiCaller().put(URLS.MANAGER_MENU_COUPON(payload.id), {
      menu_coupon: Object.assign({}, state.editMenuCoupon)
    })

    if (response.status === 200) {
      Message.success({
        message: response.data.message
      })
      commit('SET_MENU_COUPON_VISIBLE', false)
      dispatch('fetchMenuCoupons')
    } else {
      Message.error({
        message: response.data.message
      })
    }
  },
  async removeMenuCoupon({ state, dispatch, commit }, id) {
    const response = await ApiCaller().delete(URLS.MENU_COUPON(id))
    if (response.status === 200) {
      Message.success({
        message: response.data.message,
        type: 'success'
      })
      commit('SET_MENU_COUPON_VISIBLE', false)
      dispatch('fetchOwnerMenuCoupons')
    } else {
      Message.error({
        message: response.data.message
      })
    }
  },
  async removeManagerMenuCoupon({ state, dispatch, commit }, id) {
    const response = await ApiCaller().delete(URLS.MANAGER_MENU_COUPON(id))
    if (response.status === 200) {
      Message.success({
        message: response.data.message,
        type: 'success'
      })
      commit('SET_MENU_COUPON_VISIBLE', false)
      dispatch('fetchMenuCoupons')
    } else {
      Message.error({
        message: response.data.message
      })
    }
  },

  async fetchDropdownMenuCoupons({ state, commit }) {
    const response = await ApiCaller().get(URLS.MENU_COUPONS())
    if (response) {
      commit('SET_DROPDOWN_MENU_COUPONS', response.data.data)
    }
  },

  async fetchClinicNameMenuCoupons({ state, commit }) {
    const response = await ApiCaller().get(URLS.CLINIC_NAME_MENU_COUPONS())
    if (response) {
      commit('SET_CLINIC_NAME_MENU_COUPONS', response.data.data)
    }
  },

  async fetchOwnerMenuCoupons({ state, commit, rootState }) {
    const response = await ApiCaller().get(URLS.MENU_COUPONS(), {
      params: Object.assign({}, rootState.page, { query: state.queryMenuCoupon.query,
                                                  q: state.queryMenuCoupon.q,
                                                  filter: state.queryMenuCoupon.filter,
                                                  paginatePage: true,
                                                  isValid: state.queryMenuCoupon.isValid })
    })

    if (response) {
      commit('SET_OWNER_MENU_COUPONS', response.data.data)
      commit('page/SET_TOTAL', response.data.total, { root: true })
    }
  },
}

export default {
  namespaced: true,
  state, mutations, actions
}
